import React, { forwardRef } from 'react'
import { countFilterRules } from './popoverPlacement'

import './FilterPill.scss'

const FilterPill = forwardRef(({
    ruleGroup, mode = 'labelled', isOpen = false, onToggle,
}, ref) => {
    const count = countFilterRules(ruleGroup)
    if (count === 0) return null

    const handleClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onToggle()
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onToggle()
        }
    }

    const isIconOnly = mode === 'icon-only'
    const className = `pp-filter-pill${isIconOnly ? ' pp-filter-pill--icon-only' : ''}${isOpen ? ' pp-filter-pill--open' : ''}`

    const ariaLabel = isIconOnly
        ? `${count} ${count === 1 ? 'filter' : 'filters'} applied`
        : undefined

    return (
        <button
            ref={ref}
            type="button"
            className={className}
            aria-expanded={isOpen}
            aria-haspopup="dialog"
            aria-label={ariaLabel}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
        >
            <i className="fas fa-filter" aria-hidden="true" />
            {isIconOnly ? (
                <span className="pp-filter-pill__count-badge">{count}</span>
            ) : (
                <>
                    <span className="pp-filter-pill__count">{count}</span>
                    <span>{count === 1 ? 'filter' : 'filters'}</span>
                    <i
                        className={`fas fa-chevron-${isOpen ? 'up' : 'down'} pp-filter-pill__chevron`}
                        aria-hidden="true"
                    />
                </>
            )}
        </button>
    )
})

FilterPill.displayName = 'FilterPill'

export default FilterPill
